'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configEnabled = configEnabled;

var _lodash = require('lodash');

var TRUTHY_VALUES = ['true', 'yes', 't', 'y'];

/**
 * Checks a given environment variable value to determine if it contains
 * a "truthy" configuration value (true, yes, t, or y).
 * @param {String} key - the name of the environment variable
 * @returns {boolean} `true` if the env var is truthy, `false` otherwise.
 */
// eslint-disable-next-line import/prefer-default-export
function configEnabled(key) {
  return (0, _lodash.includes)(TRUTHY_VALUES, (0, _lodash.lowerCase)(process.env[key]));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/decisiv-domain-utils/build/config.js
// module id = 1490
// module chunks = 2